export function getCategoryAssociationPlatform (tpItem) {
  if (!tpItem) return ''

  const { itemCcName, itemMold, itemNamePlatform, traPlatform } = tpItem

  if (traPlatform === 'xianyu' && !itemCcName) {
    return 'xianyu'
  }
  if ((itemNamePlatform === 'pinduoduo' || itemNamePlatform === 'PINDUODUO') && !itemCcName) {
    return 'pinduoduo'
  }
  if (itemNamePlatform === '1688' && !itemCcName) {
    return '1688'
  }
  if (traPlatform === 'pddtb' && itemMold === '0') {
    return 'pinduoduo'
  }
  if (traPlatform === '1688tb' && itemMold === '0') {
    return '1688'
  }

  return ''
}

export function findCategoryAssociationCandidate (tpItems, allowLegacyPlatforms) {
  if (!Array.isArray(tpItems)) return null

  return tpItems.find(tpItem => {
    const platform = getCategoryAssociationPlatform(tpItem)

    // 闲鱼缺少分类时始终交由用户关联淘宝商品；其他平台保持原有触发条件。
    return platform === 'xianyu' || (allowLegacyPlatforms && !!platform)
  }) || null
}
